import React from 'react';
import PropTypes from 'prop-types';
import poweredBy from '../../ASUPhotos/logos/poweredBy.png';
import rogersFoundation from '../../ASUPhotos/logos/The-Rogers-Foundation-color-logo (1).png';

const RogersFoundationLogoSection = ({ tenant }) => (
  <div className="powered-by-container">
    <div className="row-to-column-landing">
      <a
        href={tenant.logoLink}
        className="nevada-container-link"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={tenant.hero} alt="Nevada System of Higher Education Logo" />
      </a>
      <a
        href={tenant.additionalLogoLink}
        target="_blank"
        rel="noopener noreferrer"
        data-cy="additional-logo-link"
      >
        <img
          alt="Rogers Foundation Logo"
          style={{ width: '100%' }}
          src={rogersFoundation}
        />
      </a>
    </div>
    <a
      className="powered-by"
      href="https://www.asu.edu/"
      target="_blank"
      rel="noopener noreferrer"
    >
      {/* <img src={poweredBy} alt="Powered By Arizona State University" /> */}
      <picture>
        <source
          media="(max-width: 799px)"
          srcset={poweredBy}
          width="480"
          height="400"
        />
        <source
          media="(min-width: 800px)"
          srcset={poweredBy}
          width="800"
          height="400"
        />
        <img
          src={poweredBy}
          alt="Powered By Arizona State University"
          width="800"
          height="400"
        />
      </picture>
    </a>
  </div>
);

export default RogersFoundationLogoSection;

RogersFoundationLogoSection.propTypes = {
  tenant: PropTypes.object.isRequired,
};
